import { initialPeriodsTableRow, IPeriodsTableRow } from 'components/BusinessToolForm/constants/periods';
import { getFormTableInitialValues2 } from 'components/BusinessToolForm/utils/helpers';

export const TOTAL_EXPENSES_FORM_NAMES = {
  CURRENCY: 'currency',
  EXPENSES_VARIANTS: 'expensesVariants',
  EXPENSES_TABLE: 'expensesTable',
  EXPENSES_TABLE_TOTAL: 'expensesTotalValues',
} as const;

export const totalExpensesVariants = [
  'Cost of sales (variable)',
  'Cost of sales (fixed)',
  'Research and development (R&D)',
  'Sales and marketing',
  'General and administrative',
  'Other operating expenses',
  'Financial expenses',
  'Non-operating expenses',
];

//  ---- COMMON ----

export interface ITotalExpensesFormValuesType {
  [TOTAL_EXPENSES_FORM_NAMES.EXPENSES_VARIANTS]: string[];
  [TOTAL_EXPENSES_FORM_NAMES.EXPENSES_TABLE]: IPeriodsTableRow[];
  [TOTAL_EXPENSES_FORM_NAMES.EXPENSES_TABLE_TOTAL]: IPeriodsTableRow;
}

export const totalExpensesInitialValues = {
  [TOTAL_EXPENSES_FORM_NAMES.EXPENSES_VARIANTS]: totalExpensesVariants,
  [TOTAL_EXPENSES_FORM_NAMES.EXPENSES_TABLE]: getFormTableInitialValues2(
    totalExpensesVariants.length,
    initialPeriodsTableRow,
  ),
  [TOTAL_EXPENSES_FORM_NAMES.EXPENSES_TABLE_TOTAL]: initialPeriodsTableRow,
};
